import { ButtonContained } from 'shared/ui/buttons/buttonContained';
import './styles.scss';
import { observer } from 'mobx-react-lite';
import {
	PreloaderWrapper,
	SkeletonButtons,
	withPreloader,
} from 'shared/ui/preloader';
import { specializationsStore } from 'entities/specializations/store/store';

const PopularSpecsWrapper = withPreloader(PreloaderWrapper, false, SkeletonButtons);
export const PopularSpecializations = observer(() => {
	return (
		<PopularSpecsWrapper
			isLoading={specializationsStore.loading}
			error={specializationsStore.error}
		>
			<div className="popular-specializations">
				{specializationsStore.specializations
					.slice(0, 5)
					.map((item, index) => (
						<ButtonContained key={index} variant={'secondary'}>
							{item.name}
						</ButtonContained>
					))}
			</div>
		</PopularSpecsWrapper>
	);
});
